module.exports = __webpack_public_path__ + "images/feature/140903_wechat_4-e3b18b25cf997aa7fbdf88fcc253194d.jpg";